

















































import { Vue, Component, Prop } from 'vue-property-decorator';
import ChatBalloon from '@/components/chat/chatBalloon.vue';
import ChatForm from '@/components/chat/chatForm.vue';
import { ChatMessageListResponse, ChatMessage } from '@/models/chatResponse';
import { Student } from '@/modules/student';
import { AttachmentFile } from '@/models/attachmentFile';
import { ReadTypes } from '@/enums/readTypes';
import { PublicTypes } from '@/enums/publicTypes';
import { UserTypes } from '@/enums/userTypes';
import { ReturnTypes } from '@/enums/returnTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import 'quill/dist/quill.core.css';

interface ChatMessageDisp extends ChatMessage {
  isScrollTop: boolean;
}

@Component({
  components: {
    'chat-balloon': ChatBalloon,
    'chat-form': ChatForm
  }
})
export default class ChatMessageView extends AvaivaledVue {
  private ReadTypes = ReadTypes;
  private PublicTypes = PublicTypes;

  @Prop() private tutorId: string;
  @Prop() private studentId: string;

  private student: Student | null = null;

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  get accountId(): string {
    return this.$store.getters['auth/accountId'];
  }

  get selectedChat(): ChatMessageListResponse {
    return this.$store.state.chat.selectedChat;
  }

  get chatMessageList(): ChatMessageDisp[] {
    if (!this.selectedChat) {
      return [];
    } else {
      const accountId = this.accountId;
      let isSet = false;
      const chatMessageListDisp = this.selectedChat.chatMessageList.map((chatMessage) => {
        const item: ChatMessageDisp = {
          id: chatMessage.id,
          sendDate: chatMessage.sendDate,
          sendUserId: chatMessage.sendUserId,
          sendUserName: chatMessage.sendUserName,
          sendUserType: chatMessage.sendUserType,
          sendUserTypeName: chatMessage.sendUserTypeName,
          readType: chatMessage.readType,
          readTypeName: chatMessage.readTypeName,
          message: chatMessage.message,
          attachmentList: chatMessage.attachmentList,
          isScrollTop: false,
        };
        if (this.tutorId === this.accountId
          && !isSet && item.readType === ReadTypes.Unread && item.sendUserId !== accountId) {
          isSet = true;
          item.isScrollTop = true;
        }
        return item;
      });

      if (!isSet && chatMessageListDisp.length > 0) {
        chatMessageListDisp[chatMessageListDisp.length - 1].isScrollTop = true;
      }

      return chatMessageListDisp;
    }
  }

  get readable() {
    if (this.tutorId !== this.accountId) {
      return false;
    }

    if (this.chatMessageList.length === 0) {
      return false;
    } else {
      return !!this.chatMessageList.find((message) => {
        return message.sendUserType === UserTypes.Student
                && message.readType === ReadTypes.Unread;
      });
    }
  }

  get studentName(): string {
    if (!this.student) {
      return '';
    } else {
      return `${this.student.lastName}　${this.student.firstName}`;
    }
  }

  get pageTitle(): string {
    return `
      <div>
        <span style="font-size:x-large; font-weight:bold;">${this.studentName}</span>
        <span style="font-size:medium; margin-left:10px;">さんとのチャット</span>
      </div>`;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  private async mounted() {
    await this.loadData();

    this.scrollDown();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Chat);
  }

  private async loadData() {
    try {
      this.student = await this.$store.dispatch('student/getStudent', this.studentId);
      await this.$store.dispatch('chat/selectChat', {
        tutorId: this.tutorId,
        studentId: this.studentId
      });
    } catch (error) {
      //
    }

    if (!this.student || !this.selectedChat) {
      this.$router.push({
        name: 'ChatList',
      });
    }
  }

  private async onPreviewUploadFile(file: AttachmentFile) {
    const result = await this.$store.dispatch('file/setAttachmentFileInfo', file);
    if (!result) { return; }

    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private async getAttachmentBlob(url: string): Promise<Blob> {
    try {
      return await this.$store.dispatch('chat/getAttachment', url);
    } catch (error) {
      throw error;
    }
  }

  // 既読登録
  private async onSeen() {
    if (!this.readable) {
      return false;
    }

    const messageIdList = this.chatMessageList
      .filter((chatMessage) => {
        return chatMessage.readType === ReadTypes.Unread
                && chatMessage.sendUserType === UserTypes.Student;
      })
      .map((chatMessage) => chatMessage.id);

    if (messageIdList.length === 0) { return; }

    try {
      await this.$store.dispatch('chat/readMessage', messageIdList);
    } catch (error) {
      this.$notify.error({
        title: '既読登録エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }

    this.$notify({
      title: '既読登録完了',
      message: 'メッセージを既読にしました',
      position: 'bottom-right',
    });

    await this.loadData();

    this.scrollDown();
  }

  // メッセージ送信
  private async inputMessage({ message, imageList }: { message: string, imageList: File[] }) {
    if (imageList.length === 0 && message === '') {
      return;
    }

    try {
      if (this.readable) {
        const messageIdList = this.chatMessageList
          .filter((chatMessage) => {
            return chatMessage.readType === ReadTypes.Unread
                    && chatMessage.sendUserType === UserTypes.Student;
          })
          .map((chatMessage) => chatMessage.id);

        if (messageIdList.length > 0) {
          await this.$store.dispatch('chat/readMessage', messageIdList);
        }
      }

      await this.$store.dispatch('chat/sendChatMessage', {
        tutorId: this.tutorId,
        studentId: this.studentId,
        schoolId: this.schoolId,
        message,
        imageList,
      });
    } catch (error) {
      this.$notify.error({
        title: 'メッセージ登録エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }

    await this.loadData();

    this.scrollDown();
  }

  private async onDeleteMessage(chatMessageId: string) {
    this.$confirm('選択したメッセージを削除します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    })
    .then(async () => {
      try {
        await this.$store.dispatch('chat/deleteChatMessage', chatMessageId);
      } catch (error) {
        this.$notify.error({
          title: 'メッセージ削除エラー',
          message: error.message,
          position: 'bottom-right',
        });
        await this.loadData();
        return;
      }

      this.$notify({
        title: 'メッセージ削除完了',
        message: 'メッセージを削除しました',
        position: 'bottom-right',
      });

      await this.loadData();
    })
    .catch();
  }

  private scrollDown() {
    this.$nextTick(() => {
      const hash = document.getElementById('last');
      if (!hash) {
        return;
      }
      hash.scrollIntoView();
    });
  }
}
